import React from 'react';
import { useState } from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import { Drawer, IconButton, useMediaQuery, useTheme } from '@mui/material';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import Sidebar from '../adminDashboard/Sidebar';
import Topbar from '../adminDashboard/Topbar';
import { Navigate } from 'react-router-dom';
import getCookies from '../utils/getCookies';
import Axios from 'axios';
import { SocketContext, socket } from '../socket';
import { getAuthHeader } from '../utils/authToken';
import { clearSessionExpiry } from '../utils/useSessionExpiry';
import ChatPanel from './ChatPanel/ChatPanel';
import { VoiceProvider } from '../voice/VoiceContext';
import SoftphoneWidget from '../voice/SoftphoneWidget';
import { PaymentLinkAccessProvider, PaymentLinkAccessGuard } from '../adminDashboard/paymentLinks/PaymentLinkAccessContext';


const keyPathValueRestrictions = {
    "/": "dashboard",
    "/admin/home": "dashboard",
    "/admin/attendance": "attendance",
    "/admin/weekly": "weekly",
    "/admin/consultationProgress": "상담 진행 상황",
    "/admin/potentialCourses": "다음 학기 예상 스케줄",
    "/admin/weekly": "weekly",
    "/admin/students": "students",
    "/admin/potentialStudents": "potential students",
    "/admin/teachers": "teachers",
    "/admin/potentialTeachers": "potential teachers",
    "/admin/courses": "courses",
    "/admin/zoom": "zoom rooms",
    "/admin/tests": "tests",
    "/admin/textbooks": "a one library",
    "/admin/addStudent": "add student",
    "/admin/addTeacher": "add teacher",
    "/admin/addCourse": "add course",
    "/admin/addSemester": "add semester",
    "/admin/addTest": "add test",
    "/admin/addZoomRoom": "add zoom room",
    "/admin/addTextbook": "add textbook",
    "/admin/homework": "homework",
    "/admin/questions": "questions",
    "/admin/schoolMaterials": "school materials",
    "/admin/calendar": "calendar",
    "/admin/newsletters": "newsletters",
    "/admin/missedCalls": "missed calls",
};

const AdminDashboardLayout = () => {
    const theme = useTheme();
    const compact = useMediaQuery(theme.breakpoints.down('md'));
    const paymentLinksPage = Boolean(useMatch('/admin/payment-links'));
    const [mobileNavigationOpen, setMobileNavigationOpen] = useState(false);
    const currentUser = getCookies("_auth_state");
    const who = currentUser ? currentUser.split(',')[2]?.split(':')[1]?.split('"')[1] : null;
    const userRole = who;
    const userId = currentUser ? currentUser.split(',')[0]?.split(':')[1]?.split('"')[1] : null;

    const [adminRestrictions, setAdminRestrictions] = useState([]);

    // scroll state
    const [scrollPosition, setScrollPosition] = React.useState(0);

    React.useEffect(() => {
        async function getAdminRestrictions() {
            await Axios.get(`${process.env.REACT_APP_URL}/api/v1/admins/${userId}/restrictions`, {
                headers: {
                    Authorization: getAuthHeader(),
                },
            }).then((response) => {
                setAdminRestrictions(response.data.restrictions);
            }).catch((error) => {
                if (error.response?.status === 401) {
                    clearSessionExpiry();
                    window.location.replace("/signin");
                }

                console.log(error.response?.data?.message);
            });
        }

        if (userRole === "admin" && userId) {
            getAdminRestrictions();
        }
    }, []);

    if (userRole !== "admin") {
        return <Navigate to="/classrooms/classes"/>;
    }

    if (adminRestrictions && adminRestrictions.length > 0) {
        const currentPath = window.location.pathname;

        // if current path is not allowed for the current user, redirect to the dashboard
        if (!paymentLinksPage && currentPath !== "/"
            && currentPath !== "/admin/home" 
            && !adminRestrictions.includes(keyPathValueRestrictions[currentPath])) {
            return window.location.replace("/");
        }
    }
    
    return currentUser ? (
        <SocketContext.Provider value={socket}>
            <PaymentLinkAccessProvider>
            <VoiceProvider>
                {paymentLinksPage && compact ? (
                    <Drawer open={mobileNavigationOpen} onClose={() => setMobileNavigationOpen(false)}>
                        <div onClick={event => { if (event.target.closest('a')) setMobileNavigationOpen(false); }}>
                            <Sidebar adminRestrictions={adminRestrictions} />
                        </div>
                    </Drawer>
                ) : <Sidebar adminRestrictions={adminRestrictions} />}
                <main 
                    className="content"
                    style={paymentLinksPage ? { minWidth: 0, flex: 1 } : undefined}
                    onScroll={(e) => {
                        setScrollPosition(e.target.scrollTop);
                    }}
                >
                    {paymentLinksPage && compact && <IconButton aria-label="Open admin navigation" onClick={() => setMobileNavigationOpen(true)} sx={{ ml: 2, mt: 1 }}><MenuOutlinedIcon /></IconButton>}
                    <Topbar adminRestrictions={adminRestrictions} />
                    {paymentLinksPage ? <PaymentLinkAccessGuard><Outlet /></PaymentLinkAccessGuard> : <Outlet context={{
                        adminRestrictions: adminRestrictions,
                        scrollPosition: scrollPosition,
                    }} />}
                </main>
                <ChatPanel />
                <SoftphoneWidget />
            </VoiceProvider>
            </PaymentLinkAccessProvider>
        </SocketContext.Provider>
    ) : <Navigate to="/signin"/>;
};

export default AdminDashboardLayout;